/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const workModeEnumSchema = z.enum(["table-service", "fast-food"]).describe("* `table-service` - Ресторан\n* `fast-food` - Фастфуд");
